<script lang="ts">

    import {_} from '../services/i18n';
    import {current_component} from "svelte/internal";
    import {ASSET_URL} from "../config";
    export let inputValue = "";
    let inputField;
    export let isFocused:boolean = false;
    //const events = getEventsAction(current_component);

    const onFocus =()=> isFocused=true;
    const onBlur =()=> isFocused=false;

</script>

<div class="search-input-wrapper w-100">

    <!--  on:input={handleInput} bind:this={inputField} -->
    <input id="searchInput" type="text" autocomplete="off" placeholder="{$_('search.placeholder')}"
           bind:value={inputValue}

           on:blur={onBlur}
           on:focus={onFocus}

           on:input />
    {#if inputValue.length == 0}
        <span id="search-icon"><img src="{ASSET_URL}/assets/img/icons/search.svg" alt="search-icon"></span>
    {:else}
        <span id="close-icon" on:click={() => inputValue = ''}><img src="{ASSET_URL}/assets/img/icons/close.svg" alt="search-icon"></span>
    {/if}
</div>

<style lang="scss">

  .search-input-wrapper{
    position: relative;
    display: flex;
    align-items: center;
    //padding:2rem;
  }

  #searchInput {
    width:100%;
    box-sizing: border-box;
    //font-size: 1.2rem;
    font-size:20px;
    color:#000000;
    caret-color:#000000;
    //padding: 14px 20px 12px 45px;
    //padding:2rem;
    border: none;
    outline: none;
    background-color:transparent;

    &:focus{
      box-shadow:none;
    }
  }

  ::placeholder{

    color:#000000;

  }

  #search-icon,#close-icon {
    position: absolute;
    right:0;
    //right:2rem;
    //font-size: 1.2rem;
    font-size:20px;

    img{

      margin:0;

    }
  }

  #close-icon{
    cursor:pointer;
  }


</style>
